module.exports = __webpack_public_path__ + "assets/img/logo-block.e98b04d2.png";